import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class RequestCancellationService {
  private cancelPendingRequests$ = new Subject<void>()

  get onCancelPendingRequests() {
    return this.cancelPendingRequests$.asObservable()
  }

  cancelPendingRequests() {
    this.cancelPendingRequests$.next()
  }
}
